import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoMovimiento, TipoMovimientoProps } from '../../interfaces/catalogos/TipoMovimientoInterface';

export const TipoMovimientos = () => {

    return new Promise<TipoMovimientoProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoMovimiento/', token)
            .then( ({ data } : { data : TipoMovimientoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoMovimiento = () => {

    return new Promise<TipoMovimientoProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoMovimiento/ObtenerTipoMovimientos', token)
            .then( ({ data } : { data : TipoMovimientoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoMovimiento = ( params: TipoMovimientoProps ) => {

    return new Promise<TipoMovimientoProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoMovimiento/Actualizar', params, token)
            .then( ({ data } : { data : TipoMovimientoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoMovimiento } );
            });

        }

    });

}

export const AgregarTipoMovimiento = ( params: TipoMovimientoProps ) => {

    return new Promise<TipoMovimientoProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoMovimiento/Agregar', params, token)
            .then( ({ data } : { data : TipoMovimientoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoMovimiento } );
            });

        }

    });

}
